export const referralProgramPromoModalAnalyticsMap = {
    b: 'get_10gb_forever',
    c: 'get_200gb',
    d: 'get_discount',
    e: 'get_1000points',
};
